module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticClass: "page-header"
  }, [_c('span', {
    attrs: {
      "id": "page-header"
    }
  }, [_vm._v(_vm._s(_vm.pageHeader))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-lg-12"
  }, [_vm._v("Allgemeine Informationen "), _c('router-link', {
    staticClass: "btn btn-primary create-new pull-right",
    attrs: {
      "to": "/areas/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "customer-information"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Name "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.name),
      expression: "model.model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "id": "firstname",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.name = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "graveyard"
    }
  }, [_vm._v("Friedhof "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.graveyard_name),
      expression: "model.model.graveyard_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "graveyard",
      "name": "graveyard",
      "required": "required",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.graveyard_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.graveyard_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon addon-primary",
    on: {
      "click": function($event) {
        _vm.selectGraveyard()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "coordinates"
    }
  }, [_vm._v("Koordinaten")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    class: _vm.coordinatesClass
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.coordinates),
      expression: "model.model.coordinates"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "coordinates",
      "name": "coordinates",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.model.coordinates)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.coordinates = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.googleURL !== null) ? _c('a', {
    staticClass: "input-group-addon",
    attrs: {
      "target": "_blank",
      "href": _vm.googleURL
    }
  }, [_vm._v("Maps")]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Kategorie "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.category_name),
      expression: "model.model.category_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category",
      "name": "category",
      "required": "required",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.category_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.category_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon addon-primary",
    on: {
      "click": function($event) {
        _vm.selectCat()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Preis (Kategorie: " + _vm._s(_vm.model.model.category_price) + " €)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.price),
      expression: "model.model.price"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "price",
      "id": "price",
      "required": "required",
      "type": "number"
    },
    domProps: {
      "value": (_vm.model.model.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.price = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "booked"
    }
  }, [_vm._v("Beschreibung")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.description),
      expression: "model.model.description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "booked",
      "id": "booked",
      "required": "required"
    },
    domProps: {
      "value": (_vm.model.model.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveArea()
      }
    }
  }, [_vm._v("Speichern")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('map-marker', {
    attrs: {
      "center": _vm.geoLocation,
      "info": _vm.pInfo
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.model.id > 0),
      expression: "model.model.id > 0"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-lg-12"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "addresses"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.graveCols,
      "src-model": _vm.model.graves,
      "add": "",
      "delete": "",
      "nosort": "",
      "select": "/graves/{:id}",
      "default-sort": _vm.defSort
    },
    on: {
      "add": function($event) {
        _vm.addRelation('graves')
      },
      "edit": _vm.editGrave,
      "delete": _vm.deleteGrave
    }
  })], 1)])])])])], 1)])]), _vm._v(" "), (_vm.visibleModal === 'addgraves') ? _c('custom-modal', {
    attrs: {
      "title": _vm.addGraveMode === 'new' ? 'Grab anlegen' : 'Grab hinzufügen',
      "ok-style": "btn btn-primary",
      "ok-text": _vm.addGraveMode === 'new' ? 'Speichern' : null
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      },
      "ok": function($event) {
        _vm.newGrave()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        _vm.addGraveMode = 'relation'
      }
    }
  }, [_vm._v("Hinzufügen")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        _vm.addGraveMode = 'new'
      }
    }
  }, [_vm._v("Anlegen")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.addGraveMode === 'relation') ? _c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('graves'),
      "cols": _vm.graveSearchCols,
      "store": "graves",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "rowAdd": _vm.saveGrave
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addGraveMode === 'new') ? _c('div', [_c('custom-input', [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Art")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graves.model.type_id),
      expression: "graves.model.type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.graves.model.type_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("[Nicht spezifiziert]")]), _vm._v(" "), _vm._l((_vm.$store.getters.models('grave_types')), function(gtype) {
    return _c('option', {
      domProps: {
        "value": gtype.id
      }
    }, [_vm._v(_vm._s(gtype.name))])
  })], 2)])]), _vm._v(" "), _c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graves.model.name),
      expression: "graves.model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "required": ""
    },
    domProps: {
      "value": (_vm.graves.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.graves.model.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Beschreibung")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graves.model.description),
      expression: "graves.model.description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "description",
      "id": "description",
      "required": ""
    },
    domProps: {
      "value": (_vm.graves.model.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.graves.model.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Preis")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graves.model.price),
      expression: "graves.model.price"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "price",
      "id": "price",
      "required": ""
    },
    domProps: {
      "value": (_vm.graves.model.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.graves.model.price = $event.target.value
      }
    }
  })])])], 1) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'selectcategories') ? _c('custom-modal', {
    attrs: {
      "title": "Kategorie auswählen"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('categories'),
      "cols": _vm.catSearchCols,
      "store": "categories",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "rowAdd": _vm.pickCat
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'selectgraveyard') ? _c('custom-modal', {
    attrs: {
      "title": "Friedhof auswählen"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('custom-table', {
    attrs: {
      "select": "",
      "src-model": _vm.$store.getters.models('graveyards'),
      "cols": [{
        name: 'Name',
        json: 'name',
        type: 'text'
      }],
      "store": "categories",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "select": _vm.pickGraveyard
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'deletegraves') ? _c('custom-modal', {
    attrs: {
      "title": "Grab entfernen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('graves')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie das Grab entfernen möchten?")])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'errSavingModel') ? _c('custom-modal', {
    attrs: {
      "ok-text": "OK"
    },
    on: {
      "ok": function($event) {
        _vm.visibleModal = ''
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_vm._v("\r\n\t\t\tFehler beim Speichern des Kunden.\r\n\t\t")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-md hidden-lg",
    attrs: {
      "href": "/areas/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-sm hidden-xs",
    attrs: {
      "href": "/areas/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs responsive-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#addresses"
    }
  }, [_vm._v("Grabstätten")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b44a27f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AreaEdit.vue
// module id = 462
// module chunks = 0